<template>
  <div>
    <div v-if="!loading">
      <AppPushNotification 
          ref="notification" 
          :title="notificationModel.title" 
          :text="notificationModel.text"
          :color="notificationModel.color" 
        />
      <div class="order-deatils-box-header row ">
        <template v-if="!isComplete">
          <div class="col-8">
            <h4 class="font-weight-bold">{{ $t('waitForPayment') }}</h4>
            <p v-html="$t('waitForPaymentDespt')"></p>
            <span>{{ $t('expireIn') }}</span>
            <div class="d-flex align-items-center h5">
              <span class="time-box">{{ timeLeft.hours }}</span>
              <span class="m-1">:</span>
              <span class="time-box">{{ timeLeft.minutes }}</span>
              <span class="m-1">:</span>
              <span class="time-box">{{ timeLeft.seconds }}</span>
            </div>
          </div>
          <div class="col-4 pt-4 ">
            <img width="100%" src="   https://cdn-icons-png.flaticon.com/512/2691/2691758.png ">
          </div>
        </template>
        <template v-else>
          <template v-if="receipt.order.orderStatus == 'FINISH'">
            <div class="col-8  d-flex align-items-center">
              <div>
                <h4 class="font-weight-bold">{{ $t('orderCompleted') }}</h4>
                <p v-html="$t('thanksForOrderingDespt')"></p>
              </div>
            </div>
            <div class="col-4 d-flex align-items-center">
              <img width="100%" src="/img/receiptPaid.png">
            </div>
          </template>
          <template v-else-if="receipt.order.orderStatus == 'CANCEL'">
            <div class="col-8  d-flex align-items-center">
              <div>
                <h4 class="font-weight-bold">{{ $t('orderCanceled') }}</h4>
                <p v-html="$t('thanksForOrderingDespt')"></p>
              </div>
            </div>
            <div class="col-4 d-flex align-items-center">
              <img width="100%" src="/img/receiptPaid.png">
            </div>
          </template>
        </template>
      </div>
      <div v-if="address.address" class="order-deatils-box row mt-2">
        <div class="col-1">
          <i class="fi fi-rs-marker h4"></i>
        </div>
        <div class="col-11 ">
          <span class="h5"> {{ $t('deliveryAddress') }}</span>
          <div class="text-grey mt-2">
            <span> {{ address.address }}</span><br>
            <span class="limited-text-one">{{ address.location }}</span>
            <span class="limited-text-one">{{ address.name }} | {{ address.phone }}</span>
          </div>
        </div>
      </div>
      <div v-else class="order-deatils-box row mt-2">
        <div class="col-1">
          <i class="fi fi-rs-marker h4"></i>
        </div>
        <div class="col-11 ">
          <span class="h5"> {{ $t('typeOfOrder') }}</span>
          <div class="text-grey mt-2">
            <span>{{ $t(getTypeOfOrder()) }}</span>
          </div>
        </div>
      </div>
      <div class="order-deatils-box row mt-2">
        <div class="col-1">
          <i class="fi fi-rr-credit-card h4"></i>
        </div>
        <div class="col-11 ">
          <span class="h5"> {{ $t('PaymentMethod') }}</span>
          <div class="row">
            <div class="col-9">
              <img class="payment-icon" :src="`/img/paymentIcon/${selectedPaymentMethod.icon}`" />
              <span class="ml-1"> {{ $t(getPaymentMethodName()) }}</span>
            </div>
            <!-- <div v-if="!isComplete" class="col-3 text-right mt-2">
              <CButton class="btn-sm bg-color-theme text-white" data-toggle="modal" data-target="#change-payment-modal">
                {{ $t('change') }}
              </CButton>
            </div> -->
          </div>
          <!-- <div class="text-grey mt-2">
                        <img class="payment-icon mr-2" :src="`/img/paymentIcon/${selectedPaymentMethod.icon}`">
                        <span> {{ $t(getPaymentMethodName()) }}</span>
                    </div> -->
        </div>
      </div>
      <div class="order-deatils-box row mt-2">
        <div class="col-1">
          <i class="fi fi-rr-shop h4"></i>
        </div>
        <div class="col-11 ">
          <span class="h5"> {{ shopName }}</span>
          <div class="text-grey mt-4">
            <div v-for="(product, index) in receipt.receiptItems" :key="index">
              <div class="order-item">
                <img v-if="product.remoteImagePath" :src="product.remoteImagePath">
                <img v-else :style="{ 'background-color': getImgColor(product.indexColor) }"
                  class="product-image-color-sm">
                <div class=" order-details">
                  <span class="limited-text h5 mb-0">{{ getCartPLUName(product) }}</span>
                  <span v-for="option in product.orderedOptions" :key="option.optionItemName"
                    class="limited-text-one text-description">• {{ getOptionItemTranslation(option) }}</span>
                  <span v-if="product.note" class="text-description">{{ $t('note') }} : {{ product.note }}</span>
                </div>
                <div class="order-quantity-price h5">
                  <div class="order-quantity h5">x{{ product.quantity }}</div>
                  <div class="order-price h5">฿{{ summary(product.netAmount) }}</div>
                </div>
              </div>
              <hr class="mt-2">
            </div>
            <table class="tracking-table">
              <tbody class="h5">
                <tr>
                  <td class="text-grey">{{ $t('docTotal') }} ({{ itemsQty }} {{$t('item') }})</td>
                  <td class="text-right">{{ convertCurrency(receipt.netAmount) }} THB</td>
                </tr>
                <tr v-if="receipt.serviceCharge > 0">
                  <td class="text-grey">{{ $t('serviceCharge') }} {{receipt.serviceChargePercent + '%'}}</td>
                  <td class="text-right">{{ convertCurrency(receipt.serviceCharge) }} THB</td>
                </tr>
                <tr v-if="!receipt.isVATIncluded">
                  <td class="text-grey">{{ $t('vat') }} {{ receipt.vatBase + '%' }})</td>
                  <td class="text-right">{{ convertCurrency(receipt.vatAmount) }}
                    THB</td>
                </tr>
                <tr v-if="receipt.discountAmount > 0">
                  <td class="text-grey">{{ $t('discount') }}</td>
                  <td class="text-right">{{ convertCurrency(receipt.discountAmount) }} THB</td>
                </tr> 
                <tr v-if="receipt.roundingValue > 0">
                  <td class="text-grey">{{ $t('roundingValue') }} </td>
                  <td class="text-right">{{ convertCurrency(receipt.roundingValue) }} THB</td>
                </tr>
                <tr style="border: none;" class="h4">
                  <td class="text-dark">{{ $t('totalAmount') }}</td>
                  <td class="text-right" :style="{ color: 'var(--bg-color-theme)' }">{{ summary(receipt.grandTotal) }} THB</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
      <div :style="{ marginBottom: isComplete ? '0px' : '95px' }" class="order-deatils-box mt-2">
        <div style="width: 100%;">
          <div class="d-flex row">
            <i class="fi fi-rr-document h4 col-1"></i>
            <span class="h5 col-11"> {{ $t('orderDetails') }}</span>
          </div>
          <table class="tracking-table">
            <tbody>
              <tr>
                <td class="text-grey ">{{ $t('orderId') }}</td>
                <td class="text-right text-grey">{{ receipt.orderNo }}</td>
              </tr>
              <tr>
                <td class="text-grey">{{ $t('orderTime') }}</td>
                <td class="text-right text-grey">{{ showCreatedAtTime(receipt.created_at) }}</td>
              </tr>
              <tr v-if="receipt.remark">
                <td class="text-grey">{{ $t('note') }}</td>
                <td style="width: 50%;" class="text-right text-grey">{{ receipt.remark }}</td>
              </tr>
            </tbody>
          </table>
          <div>
            <CButton @click="callShop()"
              style="border-radius: 30px; border-color: var(--bg-color-theme); color: var(--bg-color-theme); "
              variant="outline" block class="p-2 mt-3">
              {{ $t('contactShop') }} 
            </CButton>
          </div>
        </div>
      </div>
      <div v-if="!isComplete" class="p-3 fixed-bottom"
        style="background-color: white; padding-top:5px;  box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.1);">
        <CButton @click="handleCreateOrder()" class="btn-lg btn-selecteditem ">
          <span style=" font-size: larger;">
            {{ $t('checkOut') }}
          </span>
        </CButton>
      </div>
      <!-- Payment Modal -->
      <div class="modal fade" tabindex="-1" id="qr-payment-modal">
        <div class="modal-dialog">
          <div class="modal-content" style="background-color: unset;">
            <div class="small-modal p-0" style="background-color: white; overflow: hidden;">

              <!-- Header: ใช้สี/โลโก้ตาม method ที่เลือก -->
              <div class="payment-qr-header" :style="{ backgroundColor: selectedPaymentMethod.bgColor || '#ffffff' }">
                <img height="40px"
                    :src="`/img/paymentIcon/${selectedPaymentMethod.iconHeader || selectedPaymentMethod.icon}`"
                    alt="Payment Header" />
              </div>

              <div class="payment-qr-body text-center w-100">
                <!-- Skeleton Loader -->
                <div v-if="loadingQRData" class="text-center p-2 w-100">
                  <div class="skeleton-box mb-3" style="width: 200px; height: 200px; margin: 0 auto;"></div>
                  <div v-for="i in 2" :key="i">
                    <div class="skeleton-line w-50 mb-2 mt-4" style="height: 10px; margin: 0 auto;"></div>
                    <div class="skeleton-line w-25 mb-2" style="height: 10px; margin: 0 auto;"></div>
                    <div class="skeleton-line w-75 mb-2" style="height: 10px; margin: 0 auto;"></div>
                  </div>
                </div>

                <!-- Payment QR and Details -->
                <div v-else class="text-center w-100">
                  <h5 class="">{{ receipt?.table?.name || $t('scanForPayment') }}</h5>

                  <!-- QR (KBANK: qrCode เป็นสตริง, GHL/KBANK_GATEWAY: code_url อาจเป็นลิงก์) -->
                  <div class="d-flex align-items-center justify-content-center">

                    <vue-qrcode v-if="countdown > 0" class="img-fluid" :value="qrString" style="width: 60%" />
                    <i v-else style="font-size: 100px;" class="fi fi-rr-time-forward row m-2"></i>
                  </div>

                  <!-- ยอดเงิน + ปุ่ม Refresh -->
                  <h4 class="mt-2">
                    {{ receipt.grandTotal.toFixed(2) }} ฿
                    <i @click="checkPaymentStatus(true)" v-if="!btnLoading" style="cursor: pointer;" class="fi fi-rr-refresh h5"></i>
                    <CSpinner v-else color="dark" />
                  </h4>

                  <!-- คำเตือน -->
                  <CAlert color="danger" v-if="isAlertStatus">
                    {{ $t('haveNotPurchased') }}
                  </CAlert>

                  <!-- คำอธิบายตามเกตเวย์ -->
                  <div class="mt-1 text-muted small">
                    <template v-if="lastGatewayUsed === 'KBANK'">
                      <template v-if="selectedPaymentMethod?.type === 'qr'">
                        {{ $t('scanWithBankApp') }} <!-- สแกนด้วยแอปธนาคารของคุณ -->
                      </template>
                      <template v-else-if="selectedPaymentMethod?.type === 'creditcard'">
                        {{ $t('scanWithCreditCardApp') }} <!-- สแกนด้วยแอปของบัตรเครดิต -->
                      </template>
                      <template v-else>
                        {{ $t('scanForPayment') }} <!-- fallback -->
                      </template>
                    </template>
                    <template v-else>
                      {{ $t('scanOrOpenApp') /* ข้อความ: "สแกน หรือกดเปิดแอปเพื่อชำระเงิน" */ }}
                    </template>
                  </div>

                  <!-- เวลาหมดอายุ -->
                  <span v-if="countdown > 0" class="text-dark">
                    {{ $t('expireIn') }}: {{ formattedCountdown }} {{ $t('minute') }}
                  </span>
                  <span v-else class="text-danger">{{ $t('paymentTImeExpired') }}</span><br>

                  <!-- ปุ่มเปิดแอป: แสดงเฉพาะกรณีที่เป็นลิงก์ (GHL/KBANK_GATEWAY) -->
                  <CButton @click="openExternalLink()" v-if="isQRStringURL" class="mt-3 text-white" color="dark">
                    <div class="row pl-3 pr-3">
                      {{ $t('openApp') }} <i class="fi fi-rr-arrow-up-right-from-square ml-2"></i>
                    </div>
                  </CButton>

                  <!-- ข้อมูลร้าน/บัญชี -->
                  <h4 class="mt-3">{{ shopName }}</h4>
                  <span class="text-grey">
                    {{ $t('account') }} :
                    <!-- KBANK: ใช้ accountName จาก API; อื่นๆ ใช้ merchantName เดิม -->
                    {{ lastGatewayUsed === 'KBANK' ? (merchantName || '-') : (merchantName || '-') }}
                  </span><br>
                  <span class="text-grey">{{ $t('refNumber') }} : {{ receipt?.orderNo }}</span>
                </div>
              </div>

              <div class="payment-qr-footer">
                <CButton style="width: 100%;" data-dismiss="modal">{{ $t('closeTab') }}</CButton>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" tabindex="-1" id="payment-pending-modal">
         <button 
            v-if="showHtml"
            type="button" 
            class="refresh-btn" 
            @click="handleAfterCloseIframe"
          >
             <i class="fi fi-rr-refresh "  style="margin-top: 6px;" ></i> 
          </button>
        <div class="modal-dialog">
          <div class="modal-content" style="background-color: unset;">
            <div class=" p-0" style="background-color: white;overflow: hidden;">
              <div class="payment-info-header">
                {{ $t('billDetail') }}
              </div>
              <div class="payment-info-modal">
                <div class="text-center w-100 mt-3">
                  <div class="order-detail-box" style="z-index: 1080;">
                    <div class="row pt-2">
                      <div v-for="(item, index) in billDetails" :key="index"
                        class="col-12 d-flex justify-content-between mb-2">
                        <template>
                          <span>{{ $t(item.label) }}</span>
                          <span class="text-right">{{ item.value }}</span>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="showHtml" class="text-center p-4">
                <!-- QR Payment -->
                <div v-if="selectedPaymentMethod.type === 'qr'" class="kbank-payment-container"   :key="order_id">
                  <iframe style="width: 100%;border: unset;" class="kbank-payment-container"
                      :src="`/Payment-Gateway/embedKBankKioskQR.html?order_id=${order_id}&receiptObjectId=${receipt.objectId}&uid=${receipt.uid}&shopObjectId=${receipt.shop.objectId}&locale=${locale}&dashboardUrl=${dashboardUrl}&qrUrl=${qrUrl}&token=${token}`">
                  </iframe>
                </div>

                <!-- Credit Card Payment -->
                <div v-if="selectedPaymentMethod.type === 'credit'" class="kbank-payment-container">
                  <iframe style="width: 100%; border: unset;" class="kbank-payment-container"
                      :src="`/Payment-Gateway/embeddedKBank.html?order_id=${receipt.objectId}&amount=${receipt.grandTotal}&name=${shopName}&paymentUrl=${silomPaymentUrl}`">
                  </iframe>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="change-payment-modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content p-4">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('confirmChangePayment') }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span>&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="alert alert-warning text-sm mb-3" role="alert">
                ⚠️ {{ $t('changePaymentWarning') }}
              </div>

              <div v-for="method in filteredPaymentMethods" :key="method.type" class="payment-option mb-2">
                <label class="payment-label w-100" :for="method.type">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center">
                      <img class="payment-icon mr-2" :src="`/img/paymentIcon/${method.icon}`" />
                      {{ $t(method.name) }}
                    </div>
                  </div>
                  <div class="text-right">
                    <input type="radio" v-model="selectedNewPayment" :value="method.id" />
                  </div>
                </label>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" data-dismiss="modal">{{ $t('cancel') }}</button>
              <button class="btn bg-color-theme text-white" @click="goToPaymentgateway" data-dismiss="modal">
                {{ $t('confirm') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="c-app" style="background-color: #ffffff">
        <div class="c-wrapper">
          <div class="c-body">
            <div class="lds-ripple">
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex'
import util from '@/util/util'
import '@/util/delivery.css'
import '@/util/loader.css'
import pos from '@/services/pos'
import moment from 'moment'
import VueQrcode from 'vue-qrcode'
import payment from '@/services/payment'
import paymentUtil from '@/util/payment';
import poscrm from '@/services/poscrm'
import '@/util/menu.css';
import signed from '@/util/signed'
import AppPushNotification from '@/components/AppPushNotification.vue'
import { CButton } from '@coreui/vue';

export default {
  components: {
    VueQrcode,
    AppPushNotification
  },
  data() {
    return {
      lastGatewayUsed: null,
      loading: true,
      deliveryAddress: {},
      receipt: {},
      itemsQty: 0,
      address: {},
      isComplete: false,
      timeLeft: {
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      typeOfOrder: 0,
      status: '',
      qrString: '',
      loadingQRData: false,
      countdown: 600,
      countdownInterval: null,
      btnLoading: false,
      isAlertStatus: false,
      merchantName: 'Silom POS Co., Ltd.',
      checkPaymentInterval: null,
      timer: null,
      order_id: null,
      locale: '',
      dashboardUrl: process.env.VUE_APP_WEB_DASHBOARD_URL,
      silomPaymentUrl: process.env.VUE_APP_PAYMENT_GATEWAY_URL,
      qrUrl : process.env.VUE_APP_WEB_URL,
      billDetails: {},
      showHtml: false,
      orderShopSetting: {},
      selectedNewPayment: '',
      notificationModel: {
          color: '',
          title: '',
          text: '',
      },
      visible: false
    }
  },
  watch: {
    'receipt.created_at'(val) {
      if (val) {
        this.updateCountdown();
        if (this.timer) clearInterval(this.timer);
        this.timer = setInterval(this.updateCountdown, 1000);
      }
    },
    showHtml(val) {
      if (val) {
        console.log(val);
        
       
      }
    }
  },
  computed: {
    ...mapGetters(['shopLineOA']),
    paymentMethods() {
      if (this.selfPaymentGateway === 'KBANK' || this.selfPaymentGateway === 'KBANK_GATEWAY') {
        return util.getKbankPaymentMethods();
      }
      return util.getGHLPaymentMethods();
    },
    shopObjectId() {
      return `${localStorage.getItem('shopObjectId')}`
    },
    uid() {
      return `${localStorage.getItem('uid')}`
    },
    token() {
      return localStorage.getItem('token')
    },
    shop() {
      return this.shopLineOA.find(detail => detail.objectId === this.shopObjectId)
    },
    shopName() {
      return this.shop?.shopName || ''
    },
    logo() {
      return this.shop?.remoteImagePath || 'https://cdn-icons-png.flaticon.com/512/4711/4711299.png'
    },
    objectId() {
      return this.$route.query.objectId
    },
    paymentMethod() {
      const method = this.paymentMethods.find(m => m.type === this.receipt?.paymentMethod);
      return method ? method.type : 'UNKNOWN METHOD';
    },
    formattedCountdown() {
      const minutes = Math.floor(this.countdown / 60).toString().padStart(2, '0');
      const seconds = (this.countdown % 60).toString().padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
    selectedPaymentMethod() {
      return this.paymentMethods.find(method => method.type === this.receipt?.paymentMethod) || {};
    },
    isQRStringURL() {
      try {
        new URL(this.qrString);
        return true;
      } catch (_) {
        return false;
      }
    },
    selfPaymentGateway() {
      // OrderShopSetting → prioritize this; default "KBANK"
      const gw = (this.orderShopSetting?.selfPaymentGateway || '').toUpperCase();
      return ['KBANK', 'GHL', 'KBANK_GATEWAY'].includes(gw) ? gw : 'KBANK';
    },
    filteredPaymentMethods() {
      const ghlConfig = this.shop?.GHLMethodEnabled || {};
      const ghlEnabled = ghlConfig.enabled === true;
      const kbankEnabled = this.shop?.enabledKPaymentGateway === true;
      const gateway = this.selfPaymentGateway; // ← prioritize orderShopSetting


      const kbankGatewayMethods = [
        {
          id: 'qr',
          name: 'QRCode',
          icon: 'qrIcon.webp',
          iconHeader: 'thaiqr_banner.webp',
          bgColor: '#113566',
          type: 'qr',
        },
        { id: 'credit', name: 'creditCard', icon: 'masterCardIcon.webp', iconHeader: 'credit_.webp', bgColor: '#f5f5f5', type: 'credit' },
      ];

      const kbankMethods = [
        {
          id: 'qr',
          name: 'QRCode',
          icon: 'qrIcon.webp',
          iconHeader: 'thaiqr_banner.webp',
          bgColor: '#113566',
          type: 'qr',
        },
        { id: 'credit', name: 'creditCard', icon: 'masterCardIcon.webp', iconHeader: 'credit_.webp', bgColor: '#f5f5f5', type: 'creditcard' },
      ];


      const ghlMethods = Array.isArray(ghlConfig.methods)
        ? this.paymentMethods.filter((m) => ghlConfig.methods.includes(m.type))
        : [];


      // First, honor the selfPaymentGateway, but also respect each enable flag.
      if (gateway === 'KBANK_GATEWAY') {
        return kbankEnabled ? kbankGatewayMethods : [];
      }
      if (gateway === 'KBANK') {
        return kbankEnabled ? kbankMethods : [];
      }
      if (gateway === 'GHL') {
        // If GHL selected, still ensure GHL is actually enabled
        return ghlEnabled ? ghlMethods : [];
      }


      // Fallback (shouldn't hit because of default), but keep it safe
      if (kbankEnabled) return kbankMethods;
      if (ghlEnabled) return ghlMethods;
      return [];
    },
  },
  created() {
    this.getOrderShopSetting()
    localStorage.removeItem('receiptObjectId')
    this.getOneOrder()
    this.getPKey()
  },
  mounted() {
    // this.updateCountdown();
    this.timer = null;

    $('#qr-payment-modal').on('shown.bs.modal', () => {
      this.checkPaymentInterval = setInterval(() => {
        if (!this.loadingQRData && this.countdown > 0) {
          this.checkPaymentStatus(false);
        }
      }, 10000);
    });

    $('#qr-payment-modal').on('hidden.bs.modal', () => {
      this.stopCountdown();
      clearInterval(this.checkPaymentInterval);
      this.checkPaymentInterval = null;
      this.removeModalArtifacts();
    });
    // $('#payment-pending-modal').on('shown.bs.modal', () => {
    //   this.$nextTick(() => {
    //     this.mountKBank()
    //   })
    // })

    $('#payment-pending-modal').on('hidden.bs.modal', () => {
      this.handleAfterCloseIframe();
    });

    // ✅ เพิ่มอันนี้ (เผื่อ user กด backdrop / esc)
    $('#payment-pending-modal').on('hidden.bs.modal', async () => {
      
      await this.checkPaymentStatus()
    })


  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.countdownInterval);
    clearInterval(this.checkPaymentInterval);
    this.countdownInterval = null;
    this.checkPaymentInterval = null;
    $('#payment-pending-modal').modal('hide')
    window.removeEventListener('message', this.handlePaymentMessage);
    this.removeModalArtifacts()
  },
  methods: {
    ...util,
    getCartPLUName(list) {
        const locale = this.$i18n.locale
        const translation = list.nameTranslation || list.productPLU?.nameTranslation
        if (translation && translation[locale]) {
            return translation[locale]
        }
        return list.productPLU?.name || list.pluName || ''
    },
    getOptionItemTranslation(option) {
        const locale = this.$i18n.locale
        const translation = option.nameTranslation || option.optionItem?.nameTranslation
        if (translation && translation[locale]) {
            return translation[locale]
        }
        return option.optionItemName || ''
    },


     closeModal() {
      if (this.receipt?.receiptStatus !== 'A') {
        if (!confirm('ยังไม่ได้ชำระเงิน ต้องการปิดหรือไม่?')) return;
      }

      $('#payment-pending-modal').modal('hide');
    },
    hhandlePaymentMessage(event) {

      if (!event.data) return;

      // กรณี KBank ยิง success
      if (
        event.data === 'success' ||
        event.data?.status === 'success' ||
        event.data?.type === 'PAYMENT_SUCCESS'
      ) {
        $('#payment-pending-modal').modal('hide');

        this.getOneOrder(); // refresh status
        this.$router.push('/delivery/tracking?objectId=' + this.receipt.objectId);
      }
    },
    handleAfterCloseIframe() {
        // วิธี 1: reload ทั้งหน้า
        // window.location.reload();

        // หรือ วิธี 2: reload data อย่างเดียว (แนะนำกว่า)
        this.getOneOrder();
    },
     showNotification(title, text, color) {
        this.notificationModel = {
            color: color,
            title: title,
            text: text,
        }
        this.$refs.notification.pushNotification();
    },
    async cancelExistingPayment(gwRaw) {
      // gwRaw = 'KBank' | 'GHL'  (ใช้ค่านี้เป็น header: { gateway })
      const objectId = this.receipt?.objectId; // เช่น 1737961215268QO31C2EjEKeAcxaZ6LUb
      if (!objectId) return;

      try {
        await payment({
          url: `/gateway/payment/v1.0/${this.uid}/orders/${objectId}/cancel?exercise=true`,
          method: 'POST',
          headers: {
            gateway: gwRaw,                  // ✅ ตามที่กำหนด: ต้องเป็น { gateway: 'KBank' } / { gateway: 'GHL' }
            posObjectId: '001',
            shopObjectId: this.shopObjectId,
          },
        });
        // ไม่ต้อง popup success เสมอไป — เงียบๆ ถ้าสำเร็จ
      } catch (e) {
        // ถ้าเคสไม่มีรายการเดิมให้ยกเลิก/ยกเลิกไปแล้ว ก็ข้ามต่อได้
        console.warn('cancelExistingPayment skipped/failed:', e?.message || e);
      }
    },
    getPaymentMethodKeyName() {
      const method = this.paymentMethods.find(m => m.id === this.selectedNewPayment);
      return method ? method.type : 'UNKNOWN METHOD';
    },
    async confirmChangePayment() {
      if (!this.selectedNewPayment || this.selectedNewPayment === this.receipt.paymentMethod) {
        return;
      }

      try {
        const uid = this.uid;
        const res = await pos({
          url: `/api/v1.3/${uid}/profile/order/updatePaymentMethod`,
          method: 'post',
          data: {
            objectId: this.receipt.objectId,
            paymentMethod: this.selectedNewPayment,
          }
        });

        if (res.data?.error?.code === 0) {
          this.receipt.paymentMethod = this.selectedNewPayment;
          this.selectedNewPayment = '';
          this.$nextTick(() => {
            this.$bvToast?.success(this.$t('saveSuccess') || 'เปลี่ยนการชำระเงินสำเร็จ');
          });
        } else {
          this.$bvToast?.danger(`Error: ${res.data.error.message || 'เปลี่ยนการชำระเงินล้มเหลว'}`);
        }
      } catch (err) {
        console.error('Change payment error:', err);
        this.$bvToast?.danger('เปลี่ยนวิธีชำระเงินไม่สำเร็จ');
      }
    },
    async goToPaymentgateway() {
      if (!this.selectedNewPayment || this.selectedNewPayment === this.receipt.paymentMethod) {
        return;
      }

      if (this.deliveryAddress.name == undefined && this.orderType == 'delivery') {
        this.showNotification(this.$i18n.t('noDeliveryAddress'), this.$i18n.t('noDeliveryAddressDespt'), 'warning');
        return;
      }

      this.loading = true;

    const gwForCancel = this.lastGatewayUsedRaw||(this.selfPaymentGateway === 'GHL' ? 'GHL' : 'KBank');

    await this.cancelExistingPayment(gwForCancel);
      const uid = localStorage.getItem('uid');
      const receiptId = this.receipt.objectId; // ต้องมีค่าจาก route หรือที่อื่น

      const data = {
        objectId: receiptId,
        paymentMethod: this.getPaymentMethodKeyName(),
      };

      try {
        const res = await pos({
          url: `/api/v1.3/${uid}/profile/order/place`,
          method: 'patch',
          data: data,
        });

        if (res.data.error.code == 0) {
          // this.showNotification(this.$i18n.t('saveSuccess'), '', 'success');
          this.getOneOrder()
        } else {
          this.showNotification(`ERROR ${res.data.error.message}`, '', 'danger');
        }
      } catch (e) {
        this.showNotification('ERROR ' + e.message, '', 'danger');
      } finally {
        this.loading = false;
      }
    },
    async createOrder(opts = { gateway: 'KBANK' }) {
      const gwRaw = (opts?.gateway || 'KBANK'); 
      
      const gw = gwRaw.toUpperCase();
      this.lastGatewayUsed = gw;
      this.lastGatewayUsedRaw = gwRaw;
      this.loadingQRData = true;
      $('#qr-payment-modal').modal('show');


      const receipt = (await this.generatePaymentReceipt()) || null;
      const type = this.receipt.paymentMethod || null;

      const payload = paymentUtil.buildPaymentPayload(gw, type, receipt)

      const res = await payment({
        url: `/gateway/payment/v1.0/${this.uid}/createqr`,
        method: 'post',
        headers: { gateway: gwRaw }, // ← 🔑 Differentiate KBANK vs GHL here
        data: payload,
      });


      if (res.data?.error?.code === 0) {
        if (gw === 'KBANK') {
          this.qrString = res.data?.data?.qrCode || '';
          if (res.data?.data?.accountName) {
            this.merchantName = res.data.data.accountName;
          }
        } else {
          // GHL / KBANK_GATEWAY
          this.qrString = res.data?.data?.code_url || '';
        }
        this.loadingQRData = false;


        this.$nextTick(() => {
          if (this.checkPaymentInterval) clearInterval(this.checkPaymentInterval);
          this.checkPaymentInterval = setInterval(() => {
            if (!this.loadingQRData && this.countdown > 0) {
              this.checkPaymentStatus(false);
            }
          }, 3000);
        });


        this.startCountdown();
      } else {
        console.error('Failed to generate QR:', res.data);
        this.showNotification(this.$t('paymentError') || 'Cannot generate QR at the moment', '', 'danger');
      }
    },
    callShop() {
      window.location.href = `tel:${this.shop.tel}`
    },
    updateCountdown() {
      const now = new Date().getTime()
      const created_at = this.receipt?.created_at;
      if (!created_at) return;
      const endTime = new Date(created_at).getTime() + 24 * 60 * 60 * 1000;
      const distance = Math.max(0, endTime - now);

      if (distance > 0) {
        this.timeLeft.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        this.timeLeft.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        this.timeLeft.seconds = Math.floor((distance % (1000 * 60)) / 1000)
      } else {
        clearInterval(this.timer);
        this.timeLeft.hours = 0;
        this.timeLeft.minutes = 0;
        this.timeLeft.seconds = 0;

      }
    },
    showCreatedAtTime(time) {
      if (time) {
        return moment(time).format('DD/MM/YYYY, HH:mm');
      } else {
        return ''
      }
    },
    summary(amount) {
      return util.convertCurrency(amount)
    },
    convertCurrency(total) {
      if (typeof total !== 'number' || isNaN(total)) {
        return '-'; // or handle as needed
      }
      return util.convertCurrency(total);
    },
    getImgColor(indexColor) {
      return util.generateColor(indexColor);
    },
    async getOneOrder() {
      const uid = localStorage.getItem('uid')
      const res = await pos({
        url: `/api/v1.3/${uid}/profile/order?objectId=${this.objectId}`,
        method: 'get',
      })
      
      if (res.data.error.code == 0) {
        let order = {}
        order = res?.data?.data || {}
        this.receipt = order || {}
        this.address = this.receipt?.address || []
        this.itemsQty = this.receipt?.receiptItems?.length || 0

        if (this.receipt.receiptStatus !== 'P') {
          this.$router.push('/delivery/tracking?objectId=' + this.receipt?.objectId)
        }

        const activeItems = (order.receiptItems || []).filter(item => !item.deleted_at);

        const rawDetails = [
          { label: "totalAmount", value: +order.grandTotal || 0 },
          { label: "serviceCharge", value: +order.serviceCharge || 0 },
          { label: "vat", value: +order.vatAmount || 0 },
          { label: "orderItem", value: `${activeItems.length} ${this.$t('item')}` },
          // { label: "table", value: order.tableName || "-" },
          // { label: "numberOfGuest", value: `${order.numCust || 1} ${this.$t('guest')}` },
          { label: "orderTime", value: order.created_at ? moment(order.created_at).format('DD/MM/YYYY, HH:mm:ss') : "-" }
        ];

        this.billDetails = rawDetails.filter(item => {
          return typeof item.value !== 'number' || item.value > 0;
        }).map(item => ({
          ...item,
          value: typeof item.value === 'number' ? item.value.toFixed(2) : item.value
        }));

        this.loading = false
      }
      else if (res.data.error.code == 402 || res.data.error.code == 403) {
        this.renewToken()
      } else if (res.data.error.code == 4000) {
        this.logOut()
      }
    },
    getPaymentMethodName() {
      const method = this.paymentMethods.find(m => m.type === this.receipt.paymentMethod);
      return method ? method.name : 'UNKNOWN METHOD';
    },
    getTypeOfOrder() {
      switch (this.receipt.typeOfOrder) {
        case 1:
          return 'dine-in'
        case 3:
          return 'pickupType'
        case 4:
          return 'deliveryType'
        default:
          return ''
      }
    },
    startCountdown() {
      this.countdown = 600;
      if (this.countdownInterval) clearInterval(this.countdownInterval);
      this.countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.countdownInterval);
        }
      }, 1000);
    },
    async generatePaymentReceipt() {
      const res = await poscrm({
        url: `/api/v1.1/${this.uid}/Receipt/selforder/generatepayment`,
        method: 'post',
        data: {
          receiptObjectId: this.receipt.objectId,
          paymentType: 13
        }
      });
      if (res?.data?.error?.code == 0) {
        return res?.data?.data || null
      } else {
        return null
      }
    },
    async checkPaymentStatus(isAlert = false) {
      if (this.btnLoading) return;
      this.btnLoading = isAlert;
      this.isAlertStatus = isAlert;

      try {
        const res = await payment({
          url: `/gateway/payment/v1.0/${this.uid}/orders/${this.receipt.objectId}/check`,
          method: 'GET',
          headers: {
            gateway: this.lastGatewayUsedRaw, // << ใช้ key 'gateway' และค่า 'KBank' เมื่อเป็น KBank
            posObjectId: '001',
            shopObjectId: this.shopObjectId,
          },
        });

        let isSuccess = false;

        if (this.lastGatewayUsed === 'KBANK') {
          // ✅ กรณี KBank: success เมื่อ Receipt เป็น 'A' (หรือสำรองจาก Payment เป็น 'A')
          const r = res?.data?.data.receipt;
          const p = res?.data?.data.payment;


          isSuccess = r?.receiptStatus === 'A'; // กันไว้กรณี backend อัพเดท state กลับมาที่ this.receipt แล้ว
        } else {
          // ✅ กรณี GHL / KBank Gateway: ใช้ trade_state เดิม
          const successState = ['TRADE_SUCCESS', 'SALE', 'SUCCESS'];
          isSuccess = successState.includes(res?.data?.data?.trade_state);
        }

        if (!isSuccess) {
          if (isAlert) {
            setTimeout(() => { this.isAlertStatus = false; }, 3000);
          }
        } else {
          $('#qr-payment-modal').modal('hide');
          this.isComplete = true;
          this.stopCountdown();
          this.removeModalArtifacts();
          const receiptObjectId = this.receipt?.objectId || '';
          this.$router.push('/delivery/tracking?objectId=' + receiptObjectId);
        }
      } catch (err) {
        console.error('Error checking payment status:', err);
      } finally {
        this.btnLoading = false;
      }
    },
    openExternalLink() {
      if (this.isQRStringURL) {
        window.open(this.qrString, '_blank');
      }
    },
    stopCountdown() {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    },
    removeModalArtifacts() {
      $('.modal-backdrop').remove();
      $('body').removeClass('modal-open');
    },
    goToKbankGatewayPage() {
      const query = {
        objectId: this.receipt.objectId,
        uid: this.uid,
        shopObjectId: this.shopObjectId,
        locale: this.locale,
      };

      this.$router.push({
        path: '/delivery/paymentgateway',
        query
      });
    },
    async handleCreateOrder() {
      const ghlEnabled = this.shop?.GHLMethodEnabled?.enabled === true;

      const kbankGatewayEnabled = this.shop?.enabledKPaymentGateway === true;
      const gateway = this.selfPaymentGateway; // 'KBANK' | 'GHL' | 'KBANK_GATEWAY' 


      // Helper to bail out cleanly
      const noGateway = () => {
        this.showNotification(this.$t('paymentNotAvailable') || 'Payment temporarily unavailable', '', 'warning');
      };


      // Honor selfPaymentGateway first; then check enable flags; then graceful fallback
      if (gateway === 'KBANK') {
        this.createOrder({ gateway: 'KBank' });
        // if (kbankEnabled) return this.createOrder({ gateway: 'KBank' });
        // if (ghlEnabled) return this.createOrder({ gateway: 'GHL' });
        // return noGateway();
      }


      if (gateway === 'GHL') {
        // NOTE: Spec says: "แต่ต้องเป็นเช็ค ... กรณีเป็น GHL และ enabledKPaymentGateway" → we still honor GHL when enabled
        // if (ghlEnabled) return this.createOrder({ gateway: 'GHL' });
        // if (kbankEnabled) return this.createOrder({ gateway: 'KBank' });
        this.createOrder({ gateway: 'GHL' });
        // return noGateway();
      }


      if (gateway === 'KBANK_GATEWAY') {
        // this.createOrderKBank();
        this.createOrderKBank();
        // this.goToKbankGatewayPage()
        // if (kbankGatewayEnabled) return this.createOrderKBank();
        // // If KBank Gateway path is not enabled, try soft-fallbacks
        // if (ghlEnabled) return this.createOrder({ gateway: 'GHL' });
        // if (kbankEnabled) return this.createOrder({ gateway: 'KBank' });
        // return noGateway();
      }


      // Absolute last resort
      // if (kbankEnabled) return this.createOrder({ gateway: 'KBANK' });
      // if (ghlEnabled) return this.createOrder({ gateway: 'GHL' });
      // return noGateway();
    },
    async createOrderKBank() {
      const orderData = {
        amount: parseFloat(this.receipt.totalAmount).toFixed(2),
        currency: 'THB',
        description: "",
        source_type: 'qr',
        reference_order: this.receipt.objectId,
        ref_1: this.uid,
        ref_2: this.shopObjectId
      };
      
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_PAYMENT_GATEWAY_URL}/embedded/v1.0/kbank/order`,
          orderData
        );
        this.order_id = response.data.data.id;
        this.showHtml = true
      } catch (error) {
        console.error('Error creating order:', error);
      }
      $('#payment-pending-modal').modal('show');

    },
    async getPKey() {
      let token = signed.sign()
      await payment({
        method: 'get',
        url: "/embedded/v1.1/kbank/config/" + this.uid + "?shopObjectId=" + this.shopObjectId,
        headers: {
          authorization: token,
        },
      }).then((res) => {
        localStorage.setItem("pkey", res.data.data.pkey)
        localStorage.setItem("mid", res.data.data.mid)
        return res.data.data.pkey
      })
    },
    async getOrderShopSetting() {
      const uid = this.uid || localStorage.getItem('uid')
      const shopObjectId = this.shopObjectId || localStorage.getItem('shopObjectId')
      let params = {
        shopObjectId: shopObjectId,
      }
      try {
        await poscrm({
          method: 'get',
          url: '/api/v2.1/' + uid + '/OrderShopSetting',
          params: params,
        }).then((res) => {
          this.orderShopSetting = res.data?.data[0] || {}
        })
      } catch (error) {
        throw new Error(error)
      }
    },


  },
}
</script>
<style scoped>
.kbank-payment-container {
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 95%;
  left: 0;
}

.modal-body {
  padding: 0rem;
}

.payment-info-modal {
  height: 100vh;
  text-align: right;
  padding: 2cap;
  background: #57C785;
  background: linear-gradient(56deg, rgba(87, 199, 133, 1) 10%, rgba(222, 237, 83, 1) 100%);
}

.payment-info-header {
  background-color: #219b78;
  color: white;
  text-align: center;
  padding: 2.5cap;
  font-size: 20px;
}
.iframe-wrapper {
  position: relative;
}

.iframe-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}
.kbank-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  z-index: 9999;
}

.kbank-content {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 20px;
}
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 9999; /* สำคัญมาก กัน iframe ทับ */
  background: rgba(0,0,0,0.6);
  color: white;
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  font-size: 18px;
}
.refresh-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 9999; /* กัน iframe ทับ */
  background: rgba(0,0,0,0.6);
  color: white;
  border: none;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  font-size: 18px;
  justify-content: center;
}
</style>
